import { ReactNode } from "react";
import styles from "./Toolbar.module.css";

export function SubToolbarGroup({ children }: Readonly<{ children: ReactNode }>) {
  return <span className={styles["sub-toolbar-group"]}>{children}</span>;
}
